import React, { Component } from 'react'

class IsPresent extends Component {
  componentDidMount() {
    const { onChange } = this.props

    onChange(true)
  }
  render() {
    return <div />
  }
}

export default IsPresent